<template>
  <div class="sidebar">
    <el-menu
      :default-active="activeIndex"
      router
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-menu-item index="/mainStore/home" v-if="checkMenus('/api/main_store/home/orders/stat@get#')">
        <i class="el-icon-s-home"></i>
        <span slot="title">首页</span>
      </el-menu-item>
      <el-menu-item index="/mainStore/store" v-if="checkMenus('/api/main_store/store@get#')">
        <i class="el-icon-location"></i>
        <span slot="title">门店管理</span>
      </el-menu-item>


      <el-submenu index="/orders">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span slot="title">订单管理</span>
        </template>
        <el-menu-item index="/mainStore/orders" v-if="checkMenus('/api/main_store/orders@get#')">订单列表</el-menu-item>
        <el-menu-item index="/mainStore/orderGoodsStat" v-if="checkMenus('/api/main_store/stat/order_goods@get#')">订单菜品统计</el-menu-item>
      </el-submenu>

      <el-submenu index="/mainStore">
        <template slot="title">
          <i class="el-icon-s-shop"></i>
          <span slot="title">总店管理</span>
        </template>
        <el-menu-item index="/mainStore/user" v-if="checkMenus('/api/main_store/user@get#')">员工管理</el-menu-item>
        <el-menu-item index="/mainStore/roles" v-if="checkMenus('/api/main_store/role@get#')">权限管理</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Sidebar',
  data () {
    return {
      myPermissions:[],
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    isCollapse () {
      return !this.sidebar.opened
    },
    activeIndex () {
      const thisRoutPath = this.$route.path
      if (this.$route.name === 'details') {
        return '/tables/details'
      }
      return thisRoutPath
    }
  },
  created(){
    var storage = window.localStorage;
    this.token = storage["access_token"];
    this.initData();
  },
  methods: {

    initData(){
      var that = this;
      that.myPermissions = [];
      that.$api.get('/main_store/role/permissions', null, response => {
        if (response.status >= 200 && response.status < 300) {
          var res = response.data;
          if (res.code == 0) {
            var myPermissionsList = res.data.my_permissions;
            myPermissionsList.forEach(function(value,i){
              that.myPermissions.push(value.apiPath);
            });
            console.log(that.myPermissions);
          }else{
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        } else {
          this.$message({
            message: "服务器维护中",
            type: 'error'
          });
        }
      });
    },

    checkMenus(per){
      if(this.in_array(per,this.myPermissions)){
        return true;
      }
      return false;
    },
    in_array(search,array){
      for(var i in array){
        if(array[i]==search){
          return true;
        }
      }
      return false;
    },
  }
}
</script>

<style scoped>
  .sidebar {
    background-color: rgb(84, 92, 100);
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 100vh;
    height: 100%;
  }

  .el-menu-vertical-demo {
    min-height: 100vh;
    height: 100%;
  }

  .el-menu-item.is-active,
  .el-submenu.is-active >>> .el-submenu__title {
    background: #484e5c !important;
  }

  .el-submenu .el-menu-item {
    padding-left: 60px !important;
    min-width: auto;
  }
  .el-submenu.is-active .el-menu-item {
    background: #484e5c !important;
  }
  .el-submenu.is-active .el-menu-item.is-active  {
    background: #3a4046 !important;
  }
  .el-submenu .el-menu-item:hover {
    padding-left: 60px !important;
    background: rgb(67, 74, 80) !important;
  }
  .el-menu-item i {
    padding-bottom: 4px;
  }

  .el-submenu__title i {
    padding-bottom: 4px;
  }

  @media all and (max-width: 768px) {
    .el-menu--collapse {
      width: 0;
      overflow: hidden;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/sidebar/MainStoreSidebar.vue